import type { TouristGroupRoom } from '@/shared/model';
import { isKid } from './touristAge';

export interface TouristGroupRequestParams {
  adults: number;
  kids: number;
  infants: number;
  kidsAges: number[];
}

export function toTouristGroupParams(room: TouristGroupRoom): TouristGroupRequestParams {
  return {
    adults: room.adults || 0,
    kids: room.kids || 0,
    infants: room.infants || 0,
    kidsAges: (room.ages ?? [])
      .map(Number)
      .filter((age) => isKid(age))
      .sort((left, right) => left - right),
  };
}
